import { supabase } from '../supabaseClient';

// 跨日快取（按 companyId 分存）
let cachedDepartments = {};
let cacheDate = null;

function ensureCacheDate() {
  const today = new Date().toISOString().slice(0, 10);
  if (cacheDate !== today) {
    cachedDepartments = {};
    cacheDate = today;
  }
}

// 取得所有部門（直查 DB）
export const getDepartments = async () => {
  try {
    const { data, error } = await supabase
      .from('departments')
      .select('*, company:companies(id, name)')
      .order('name');
    return { data, error };
  } catch (error) {
    console.error('Error fetching departments:', error);
    return { data: null, error };
  }
};

// 取得特定公司的部門（直查 DB + 跨日 cache）
export const getDepartmentsByCompany = async (companyId) => {
  if (!companyId) return { data: [], error: null };

  ensureCacheDate();

  if (cachedDepartments[companyId]) {
    return { data: cachedDepartments[companyId], error: null };
  }

  try {
    const { data, error } = await supabase
      .from('departments')
      .select('*, company:companies(id, name, marquee_text)')
      .eq('company_id', companyId)
      .order('name');

    if (!error && data) {
      cachedDepartments[companyId] = data;
    }

    return { data, error };
  } catch (error) {
    console.error('Error fetching departments by company:', error);
    return { data: null, error };
  }
};

/**
 * 取得指定部門的 Daily Report 可見成員 IDs
 * 直查 departments.settings.daily_report_visible_member_ids
 * @param {string|null} departmentId - 目標部門 ID
 * @returns {Promise<{data: string[], error: any}>}
 */
export const getDailyReportVisibleMembers = async (departmentId = null) => {
  try {
    if (!departmentId) return { data: [], error: null };

    const { data, error } = await supabase
      .from('departments')
      .select('id, settings')
      .eq('id', departmentId)
      .single();

    if (error) throw error;

    const visibleMemberIds = data?.settings?.daily_report_visible_member_ids || [];
    return { data: visibleMemberIds, error: null };
  } catch (error) {
    console.error('Error fetching daily report visible members:', error);
    return { data: [], error };
  }
};

/**
 * 更新指定部門的 Daily Report 可見成員 IDs
 * 直接更新 departments.settings.daily_report_visible_member_ids
 * @param {string[]} memberIds - 成員 UUID 陣列
 * @param {string|null} departmentId - 目標部門 ID
 * @returns {Promise<{data: any, error: any}>}
 */
export const updateDailyReportVisibleMembers = async (memberIds, departmentId = null) => {
  try {
    if (!departmentId) throw new Error('departmentId is required');

    // 1. 先讀取目前的 settings
    const { data: dept, error: fetchError } = await supabase
      .from('departments')
      .select('id, settings')
      .eq('id', departmentId)
      .single();

    if (fetchError) throw fetchError;

    // 2. 合併更新 settings
    const currentSettings = dept?.settings || {};
    const updatedSettings = {
      ...currentSettings,
      daily_report_visible_member_ids: memberIds,
    };

    // 3. 寫回 DB
    const { data, error } = await supabase
      .from('departments')
      .update({ settings: updatedSettings })
      .eq('id', departmentId)
      .select()
      .single();

    if (error) throw error;

    return { data, error: null };
  } catch (error) {
    console.error('Error updating daily report visible members:', error);
    return { data: null, error };
  }
};
